import { useHeaderHeight } from '@react-navigation/elements'
import { Platform, StyleSheet, View } from 'react-native'
import { useTheme } from 'react-native-paper'
import { useLiveMonitor } from '@/hooks/monitor/useLiveMonitor'
import { MonitorHeader } from '@/ui/monitor/MonitorHeader'
import { CardsView } from '@/ui/monitor/views/CardsView'

export default function MonitorPage() {
    const theme = useTheme()
    const headerHeight = useHeaderHeight()
    const paddingTop = Platform.OS === 'ios' ? headerHeight : 0
    const data = useLiveMonitor()

    return (
        <View style={[styles.container, { backgroundColor: theme.colors.background, paddingTop }]}>
            <MonitorHeader userLocations={data.userLocations} />
            <CardsView
                userLocations={data.userLocations}
                locationCircles={data.locationCircles}
                isPending={data.isPending}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
})
